export const formatReadableDateTime = (isoString) => {
  if (!isoString) {
    return "N/A";
  }
  const date = new Date(isoString);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "America/Los_Angeles",
  };
  return new Intl.DateTimeFormat("es-ES", options)
    .format(date)
    .replace(/\u00A0/g, " ");
};

export const formatDateTime = (isoString, tz = "America/Los_Angeles") => {
  if (!isoString) return "N/A";
  const d = new Date(isoString);
  if (isNaN(d)) return "N/A";

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: tz,
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
    .formatToParts(d)
    .reduce((acc, p) => ((acc[p.type] = p.value), acc), {});

  return `${parts.month}/${parts.day}/${parts.year} ${parts.hour}:${parts.minute}`;
};

export const formatReadableDate = (isoString) => {
  const date = new Date(isoString);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "America/Los_Angeles",
  };
  return new Intl.DateTimeFormat("es-ES", options).format(date);
};

export const formatReadableTime = (isoString) => {
  const date = new Date(isoString);
  const options = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "America/Los_Angeles",
  };
  return new Intl.DateTimeFormat("es-ES", options).format(date);
};

export const convertToPST = (datetime) => {
  if (!datetime) {
    return "";
  }
  const lang = localStorage.getItem("i18nextLng");

  return new Date(datetime).toLocaleDateString(lang, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: "America/Los_Angeles",
  });
};

// Convert to local time and format as 'YYYY-MM-DDTHH:MM'
export const toDatetimeLocal = (datetime) => {
  if (datetime) {
    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  } else return null;
};

export const getLocalDateTime = () => {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const local = new Date(now.getTime() - offset * 60 * 1000);
  return local.toISOString().slice(0, 16);
};

export const getLocalDate = (datetime) => {
  if (!datetime) return null;
  const date = new Date(datetime);
  const offset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - offset * 60 * 1000);
  return local.toISOString().slice(0, 10);
}